import React, { Component } from 'react';
import SDAFiles from './SDAFiles';
import CustomModal from '../../../../shared/CustomModal';
import DeviceDetailsUploadContainer from '../../Upload';
import { fetchDeviceSDAFiles } from '../../../../services/java/java-services';

class SDAFilesContainer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			deviceSlNo: props.deviceDetails?.details?.serialNo,
			sdaList: [],
			latestFileContent: '',
			sdaDownloadError: null,
			sdaFetchError: null,
			loading: false,
			showUploadModal: false,
			showUploadSuccessMsg: false
		}
	}

	componentDidMount() {
		this.fetchSDAList();
	}

	/**
	 * @description Function to fetch SDA list
	 * @memberof SDAFilesContainer
	 */
	fetchSDAList = () => {
		this.setState({ loading: true })
		fetchDeviceSDAFiles(this.state.deviceSlNo, (err, res) => {
			if (err) {
				this.setState({ loading: false, sdaFetchError: err, sdaList: [], latestFileContent: '' })
			} else {
				this.setState({ loading: false, sdaFetchError: null, sdaList: res?.data?.uploadedTextFileList || [], latestFileContent: res?.data?.content })
			}
		})
	}

	/**
	 * @description Function to show or hide sda upload modal
	 * @memberof SDAFilesContainer
	 */
	toggleUploadModal = () => {
		this.setState(prevState => {
			return {
				showUploadModal: !prevState.showUploadModal
			}
		})
	}

	/**
	 * @description Function to receive the event once uplaod is success
	 * @memberof SDAFilesContainer
	 */
	onFileUploadSuccess = () => {
		this.setState({ showUploadModal: false, showUploadSuccessMsg: true })
		this.fetchSDAList();
		setTimeout(() => {
			this.setState({ showUploadSuccessMsg: false })
		}, 10000);
	}

	render() {
		const { deviceDetails } = this.props;
		const { loading, sdaList, latestFileContent, sdaFetchError, sdaDownloadError, showUploadModal, showUploadSuccessMsg } = this.state;
		return <>
			<SDAFiles
				loading={loading}
				sdaList={sdaList}
				latestFileContent={latestFileContent}
				sdaDownloadError={sdaDownloadError}
				sdaFetchError={sdaFetchError}
				showUploadSuccessMsg={showUploadSuccessMsg}
				toggleUploadModal={this.toggleUploadModal}
			/>

			{/* Modal to show upload file modal */}
			<CustomModal
				id="upload-sda-modal"
				show={showUploadModal}
				title="Upload SDA File"
				isComponent={true}
				hideClose={true}
				dialogClassName="file-upload-dialog"
				closeAction={this.toggleUploadModal}>
				<DeviceDetailsUploadContainer
					toggleUploadModal={this.toggleUploadModal}
					deviceDetails={deviceDetails}
					handleUploadSuccess={this.onFileUploadSuccess}
				/>
			</CustomModal>
		</>;
	}
}

export default SDAFilesContainer;
